<template>
  <!-- 保持与页面卡片完全一致的结构与样式 -->
  <div class="rounded-lg border border-blue-200 bg-blue-50 p-4">
    <div class="flex items-center justify-between mb-2">
      <h3 class="text-lg font-semibold text-blue-900">国密加密传输说明</h3>
      <span
        class="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full bg-blue-100 text-blue-700"
        >SM2 / SM3 / SM4</span
      >
    </div>
    <div class="space-y-3 text-sm text-blue-900 leading-6">
      <p>
        本接口支持国密加密（SM2/SM3/SM4）。<br />启用方式：企业准备一套SM2密钥（公钥交付给见知，私钥自行保存），同时保存见知提供的见知公钥。
      </p>
      <div>
        <p class="font-medium">启用国密加密的请求步骤：</p>
        <ol class="list-decimal list-inside space-y-1">
          <li>
            随机生成一个16位字符串作为SM4密钥（仅数字和大小写字母，不含特殊字符）。
          </li>
          <li>
            将原始报文使用步骤1的SM4密钥进行加密，得到密文，base64编码后赋值给
            <code class="bg-white/60 px-1 py-0.5 rounded">reqData</code>
            参数。原始报文把请求参数转换成json字符串：
            <code
              class="bg-white/60 px-1 py-0.5 rounded break-all whitespace-normal inline-block max-w-full"
              >{{ sampleJsonToShow }}</code
            >（无值传空字符串）。
          </li>
          <li>
            使用见知公钥（SM2）加密步骤1的SM4密钥，赋值到请求 Header 的
            <code class="bg-white/60 px-1 py-0.5 rounded">xencio-key</code>。
          </li>
          <li>
            使用SM2的签名算法，用企业SM2私钥，对原始报文进行签名，得到签名字符串，赋值给
            <code class="bg-white/60 px-1 py-0.5 rounded">sign</code> 参数。
          </li>
          <li>
            最终请求体：<code class="bg-white/60 px-1 py-0.5 rounded"
              >{ "reqData": "...", "sign": "..." }</code
            >，并携带上述 Header。
          </li>
        </ol>
      </div>
      <div>
        <p class="font-medium">启用国密加密的响应解析：</p>
        <ol class="list-decimal list-inside space-y-1">
          <li>
            读取响应 Header 的
            <code class="bg-white/60 px-1 py-0.5 rounded">xencio-key</code
            >，用企业SM2私钥解密，得到SM4密钥。
          </li>
          <li>
            用步骤1得到的SM4密钥解密响应体中的
            <code class="bg-white/60 px-1 py-0.5 rounded"
              >respData（base64解码后）</code
            >，得到原始响应报文的json字符串）。
          </li>
          <li>
            对步骤2得到的原始响应报文，接收到的sign参数，使用见知公钥（SM2）进行验签操作。
          </li>
        </ol>
      </div>
      <p class="text-xs text-blue-700">
        提示：原始响应报文即为当前接口的响应参数。
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ sampleJson?: string }>();

const defaultSampleJson =
  '{"businessTransNo":"","payAmount":"","crossBank":"0","fromAccountNo":"","fromAccountName":"","toAccountNo":"","toAccountName":"","toAccountType":"0","toBankName":"","toBankNo":"","scheduleDate":"","purpose":"","postscript":"","summary":"","metaJson":"{\\"projectInfo\\":\\"测试项目信息\\"}"}';

const sampleJsonToShow = props.sampleJson ?? defaultSampleJson;
</script>
